import Amount from 'shared/components/Amount';
import MultiCurrencyData from 'shared/components/MultiCurrencyData';
import type { Saldo } from 'shared/hooks/use-load-dashboard';
import type { CurrencyCode } from 'types/currency';

type Props = {
  data: Saldo;
  currency: CurrencyCode;
};

export default function BankStatusAmount({ data, currency }: Props) {
  const { localizedTotal, ...rest } = data;

  const currencies = Object.keys(rest).filter(e => e !== currency);
  if (!currencies.length) {
    return <Amount value={localizedTotal} prefix={localizedTotal >= 0 ? '+ ' : undefined} />;
  }

  return (
    <Amount
      style={{ display: 'flex', alignItems: 'center' }}
      value={localizedTotal}
      prefix={localizedTotal >= 0 ? '+ ' : undefined}
    >
      <MultiCurrencyData data={data} prefix="+ " />
    </Amount>
  );
}
